<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Contact Us</h1>
          <p>Do you have questions or comments, send us a message.</p>
        </div>
        <div class="columns is-vcentered">
          <div class="column is-6 is-offset-3">
            <div class="flex-card light-bordered light-raised">
              <div class="card-body">
                <ValidationObserver ref="observer" v-slot="{ passes }">
                  <form @submit.prevent="passes(submit)">
                    <div class="columns is-centered">
                      <div class="column is-6-desktop">
                        <div class="control">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Email Address"
                            rules="required|email"
                          >
                            <b-field
                              label="Email Address"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.email" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                        <div class="control has-margin-top-5">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Name"
                            rules="required"
                          >
                            <b-field
                              label="Name"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.firstName" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                        <div class="control has-margin-top-5">
                          <b-field label="Company">
                            <b-input v-model="item.companyName" />
                          </b-field>
                        </div>
                        <div class="control has-margin-top-5">
                          <b-field label="Phone Number">
                            <b-input v-model="item.phone" />
                          </b-field>
                        </div>
                        <div class="control has-margin-top-5">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Message"
                            rules="required"
                          >
                            <b-field
                              label="Message"
                              :type="{ 'is-danger': errors.length > 0 }"
                              :message="errors[0]"
                            >
                              <b-input v-model="item.message" type="textarea" />
                            </b-field>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                    <div class="has-text-centered">
                      <div class="is-block has-margin-bottom-15">
                        <button
                          class="button is-primary is-medium btn-align no-lh raised primary-btn"
                          type="submit"
                          :disabled="loading"
                          :class="{ 'is-loading': loading }"
                        >
                          Send</button
                        ><br />
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CardComponent from '@/components/CardComponent'
import ContactApi from '@/api/contact'

export default {
  name: 'Contact',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Contact Us',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Do you have questions or comments, send us a message.'
      }
    ]
  },
  data() {
    return {
      loading: false,
      item: {}
    }
  },
  created() {
    this.getUser().then(user => {
      this.item = {
        userId: user.id,
        email: user.email,
        firstName: `${user.first_name} ${user.last_name}`,
        companyName: user.company,
        phone: user.phone
      }
    })
  },
  mounted() {},
  methods: {
    ...mapActions(['getUser']),
    async submit() {
      this.loading = true
      try {
        await ContactApi.sendMessage(this.item)
        this.$buefy.toast.open({
          message: 'Your message has been send',
          position: 'is-top',
          type: 'is-success'
        })
        this.item = {}
        this.$refs.observer.reset()
        this.loading = false
      } catch (err) {
        this.$buefy.toast.open({
          message: 'Error sending message',
          position: 'is-top',
          type: 'is-danger'
        })
        this.loading = false
      }
    }
  }
}
</script>
